var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "md-layout md-gutter md-alignment-top-center" }, [
      _c("div", {
        staticClass:
          "md-layout-item md-size-25 md-small-size-100 md-xsmall-size-100"
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "md-layout-item md-size-50 md-small-size-100 md-xsmall-size-100"
        },
        [
          _c(
            "form",
            {
              attrs: { novalidate: "" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.validatePass.apply(null, arguments)
                }
              }
            },
            [
              _c(
                "md-card",
                [
                  _c("md-card-header", [
                    _c("div", { staticClass: "md-title" }, [
                      _vm._v("Passwort ändern")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("md-card-content", [
                    _c("div", { staticClass: "md-layout md-gutter" }, [
                      _c(
                        "div",
                        { staticClass: "md-layout-item md-size-100" },
                        [
                          _c(
                            "md-field",
                            { class: _vm.getValidationClass("password") },
                            [
                              _c("label", [_vm._v("Passwort")]),
                              _vm._v(" "),
                              _c("md-input", {
                                attrs: {
                                  name: "password",
                                  type: "password",
                                  disabled: _vm.sending
                                },
                                model: {
                                  value: _vm.form.password,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "password", $$v)
                                  },
                                  expression: "form.password"
                                }
                              }),
                              _vm._v(" "),
                              !_vm.$v.form.password.required
                                ? _c("span", { staticClass: "md-error" }, [
                                    _vm._v("Das Passwort wird benötigt")
                                  ])
                                : !_vm.$v.form.password.minlength
                                ? _c("span", { staticClass: "md-error" }, [
                                    _vm._v(
                                      "Ungültiges Passwort, bitte verwenden Sie mindestens 8\n                    Zeichen."
                                    )
                                  ])
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "md-layout-item md-size-100" },
                        [
                          _c(
                            "md-field",
                            { class: _vm.getValidationClass("repassword") },
                            [
                              _c("label", [_vm._v("Passwort wiederholen")]),
                              _vm._v(" "),
                              _c("md-input", {
                                attrs: {
                                  name: "repassword",
                                  type: "password",
                                  disabled: _vm.sending
                                },
                                model: {
                                  value: _vm.form.repassword,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "repassword", $$v)
                                  },
                                  expression: "form.repassword"
                                }
                              }),
                              _vm._v(" "),
                              !_vm.$v.form.repassword.required
                                ? _c("span", { staticClass: "md-error" }, [
                                    _vm._v("Das Passwort wird benötigt")
                                  ])
                                : !_vm.$v.form.repassword.minlength
                                ? _c("span", { staticClass: "md-error" }, [
                                    _vm._v(
                                      "Ungültiges Passwort, bitte verwenden Sie mindestens 8\n                    Zeichen."
                                    )
                                  ])
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    this.error
                      ? _c("span", { staticClass: "md-error" }, [
                          _vm._v(
                            "Die Passwortänderung war nicht erfogreich, folgen Sie dem\n              Reset-Link aus der Email erneut und versuchen Sie es ein\n              weiteres mal oder kontaktieren Sie uns unter\n              "
                          ),
                          _c("strong", [_vm._v("werner@dfki.de")]),
                          _vm._v(".")
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c(
                    "md-card-actions",
                    [
                      _c(
                        "md-button",
                        {
                          staticClass: "md-primary",
                          attrs: { type: "submit" }
                        },
                        [_vm._v("Anmelden")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("div", {
        staticClass:
          "md-layout-item md-size-25 md-small-size-100 md-xsmall-size-100"
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e122372a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e122372a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/authentication/signin/forgotpass/ForgotPass.vue
// module id = null
// module chunks = 